import { component } from '../../../../scripts/core/Component'
import { Button } from '../../../ui/button/index'

@component('headerButton')
class HeaderButton extends Button {
  constructor (context) {
    super(context)
  }
}

export {
  HeaderButton
}


// WEBPACK FOOTER //
// ./components/main/header/headerButton/index.js